module.exports = __webpack_public_path__ + "media/packs/images/flags/BN-6a88f92935a4bff25be41e3d6706209a.png";